import { v4 as uuidv4 } from "uuid";

export default function generateUuidString() {
  return uuidv4();
}
